<div class="campanhas-page">
  <app-page-header title="Integração" />

  <app-filter-bar [fields]="filterFields()" (filtersChange)="onFiltersChange($event)" />

  <section aria-labelledby="integracao-campanhas-section-title">
    <!-- <h2 id="integracao-campanhas-section-title" class="page-section-title">
      Campanhas encerradas
    </h2> -->

    @if (campanhasFiltradas().length === 0) {
      <app-empty-state />
    } @else {
      <app-data-table ariaLabel="Campanhas encerradas">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Status</th>
            <th scope="col">Início</th>
            <th scope="col">Fim</th>
            <!-- <th scope="col">Tipo</th> -->
          </tr>
        </thead>
        <tbody>
          @for (campanha of campanhasPaginadas(); track campanha.id) {
            <tr>
              <td>
                <a
                  class="table-link"
                  [routerLink]="['/integracao', campanha.id]"
                  data-testid="integracao-campanha-link"
                >
                  {{ campanha.nome }}
                </a>
              </td>
              <td>
                <!-- A cor sai da descrição, não do código: aqui toda campanha é Encerrada e o
                     que distingue as linhas é o andamento da integração. -->
                <app-status-badge [status]="campanha.statusLabel" />
              </td>
              <td>{{ formatDate(campanha.dataInicio) }}</td>
              <td>{{ formatDate(campanha.dataFim) }}</td>
              <!-- <td>{{ campanha.tipo }}</td> -->
            </tr>
          }
        </tbody>
      </app-data-table>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize"
        [totalItems]="campanhasFiltradas().length"
        (pageChange)="onPageChange($event)"
      />
    }
  </section>
</div>
